import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import useTranslationSetup from "../../utils/useTranslationSetup";
import celebrationGreenBckImg from "../../assets/celebration_with_green_bck_img.svg";
import "./styles.css";

const AudioSaveSuccessDialog = ({
  isDialogOpen,
  header,
  description,
  btnText,
  onClick,
}) => {
  const { activeLanguage } = useTranslationSetup();

  return (
    <Dialog className="custom-dialog audio-save-success" open={isDialogOpen}>
      <DialogTitle className="audio-save-success-title">
        <img
          src={celebrationGreenBckImg}
          alt="celebration_with_green_bck_img"
          className="audio-save-success-celebration-img"
        />
        <Typography
          fontSize="14px"
          textAlign="center"
          margin="0 5px 8px"
          color="#353535"
          className="custom-ff-medium"
          lang={activeLanguage}
        >
          {header}
        </Typography>
        <Typography
          fontSize="14px"
          textAlign="center"
          padding="0 12% 0px"
          color="#6E6E6E"
          className="custom-ff-regular"
          lang={activeLanguage}
        >
          {description}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box>
          <Button
            className="audio-save-success-get-result-button btn-primary"
            variant="contained"
            lang={activeLanguage}
            disableElevation
            onClick={onClick}
          >
            {btnText}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default AudioSaveSuccessDialog;
